export default __webpack_public_path__ + "static/media/outlook-calendar.319ce21c.png";